export const PREFIX_COLLECTION_SELECT = {
  types: '__TYPE-PREFIX__',
  collections: '__COLLECTION-PREFIX__',
  brands: '__BRAD-PREFIX__'
};
